export const CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME = {
  BRAND_DESCRIPTION: 'BRAND_DESCRIPTION',
  PRODUCT: 'PRODUCT',
  COMMISSION_AMOUNT: 'COMMISSION_AMOUNT',
  INSPECTION_AGREEMENT: 'INSPECTION_AGREEMENT',
  PERIOD: 'PERIOD',
  DELIVERY_COMPANY: 'DELIVERY_COMPANY',
} as const;

export const CAMPAIGN_FORM_STEP_ONE_FIELD_NAME = {
  DESCRIPTION: 'description',
  COMMISSION_AMOUNT: 'commissionAmount',
  IS_FASTTRACK_SCHEDULE: 'isFasttrackSchedule',
  IS_SINGLE_DAY_POSTING: 'isSingleDayPosting',
  PERIOD: {
    RECRUIT_STARTS_AT: 'recruitStartsAt',
    RECRUIT_ENDS_AT: 'recruitEndsAt',
    SELECTION_STARTS_AT: 'selectionStartsAt',
    SELECTION_ENDS_AT: 'selectionEndsAt',
    PRODUCT_DEPLOY_AT: 'productDeployAt',
    POSTING_STARTS_AT: 'postingStartsAt',
    INSPECTION_SUBMIT_DUE_DT: 'inspectionSubmitDueDt',
    INSPECTION_FEEDBACK_DUE_DT: 'inspectionFeedbackDueDt',
    POSTING_ENDS_AT: 'postingEndsAt',
  },
  DELIVERY_COMPANY_NAME: 'deliveryCompanyName',
} as const;
